/**
 * Cross-thread pending email attachments for the triage feed.
 *
 * One tenant-scoped query (no N+1) backed by GET /relay/email-attachments.
 * Each row carries its parent thread id + subject so the feed can group
 * attachments as subcards under their thread.
 */

import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getRelayApi} from '../api/relay-api';
import {relayKeys} from '../query-keys';

export function useAllPendingAttachments() {
  const tenantId = useRequiredTenantId();
  return useQuery({
    queryKey: relayKeys.attachments.pendingForTenant(tenantId),
    queryFn: async () => getRelayApi().listPendingTenantAttachments(),
    staleTime: 30_000,
    // The EnrichmentSweeper auto-dismisses high-confidence attachments
    // asynchronously (no push channel to the browser), so an open Triage view
    // needs to poll to notice — otherwise it can keep offering Keep/Dismiss on
    // a file the backend already dismissed.
    refetchInterval: 30_000,
  });
}
